import React from 'react'
import { InputGroup } from 'react-bootstrap'
import { TextInput } from '../Text/TextInput'
import { BusyButton } from '@ztechapps/webui.button'

export type SearchInputProps = {
  onSearch: (value: string) => void
  value: string
  placeholder?: string
  disabled?: boolean
  isBusy?: boolean
}
export const SearchInput = ({ onSearch, value, disabled, placeholder = 'Search', isBusy }: SearchInputProps) => {
  const [textValue, setTextValue] = React.useState(value)

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSearch(textValue)
      }}
    >
      <InputGroup>
        <TextInput
          type="search"
          placeholder={placeholder}
          disabled={disabled}
          submitting={isBusy}
          value={textValue}
          onChange={(e) => setTextValue(e.target.value)}
        />
        <BusyButton
          type="submit"
          icon="search"
          isBusy={isBusy}
          disabled={disabled}
          onClick={() => onSearch(textValue)}
        />
      </InputGroup>
    </form>
  )
}
